import { render, staticRenderFns } from "./loyaltyStoreCategoryCard.vue?vue&type=template&id=5c2abf96&"
import script from "./loyaltyStoreCategoryCard.vue?vue&type=script&lang=js&"
export * from "./loyaltyStoreCategoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports